import { Outlet, useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import Header from "../../components/General/Header";
import SideBar from "../../components/General/SideBar";
import Wrapper from "../../StylesWrappers/General/sharedLayout";
import Content from "../../StylesWrappers/General/Content";
import { RootState } from "../../store";
import { capitalize } from "../../utils/capitalize";

const SharedLayout = () => {
  const { jobID } = useParams();

  const { btnContent } = useSelector((store: RootState) => store.editJobStore);

  const pathname = useLocation().pathname; // Get the pathname
  const splitPathname = pathname?.split("/"); // Array-lize the pathname based on "/"
  const headerName = splitPathname[splitPathname.length - 1]; // Pick the last element of the array
  const splitLastElement = headerName.split("-"); // Array-lize the last element based on "-"

  // Capitalize each element in the array
  const capitalizeEachElement = splitLastElement.map((each) => {
    return capitalize(each);
  });

  const newHeaderTitle = capitalizeEachElement.join(" "); // Join elements of the array

  const dynamicDisplayOfHeaderTitle = () => {
    if (btnContent === "Update" && headerName === "add-job") {
      return "Update-job"; // Display this head title only if job is to be updated and in the "add-job" page
    }
    if (jobID) {
      return "Job Details";
    }
    return capitalize(newHeaderTitle);
  };

  return (
    <Wrapper>
      <Header dynamicDisplayOfHeaderTitle={dynamicDisplayOfHeaderTitle()} />

      <section className="sidebar_and_outlet">
        <SideBar
          navSection="nav-section"
          smScreenClose="lg-screen-close-icon"
          toggleNavSection="remove-nav"
        />
        <SideBar
          navSection="small-nav-section"
          smScreenClose="sm-screen-close-icon"
        />
        <Content>
          <Outlet />
        </Content>
      </section>
    </Wrapper>
  );
};

export default SharedLayout;
